import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    makeHandlerChainAwaitable,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { BillToModel, CountryModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    ValidateBillingAddress,
    chain,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";

type HandlerType = Handler<
    {},
    {
        cart: Cart;
        billTo: BillToModel;
        shipTo: ShipToModel;
        country: CountryModel | undefined;
        shipTos: ShipToModel[];
    }
>;

export const ValidateBillingAddressExtended: HandlerType = async ({ dispatch, getState, billTo }) => {
    const state = getState();
    const {
        pages: {
            checkoutShipping: { billingAddressFormState },
        },
    } = state;
    if (!billingAddressFormState) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const billingAddressErrors = await awaitableValidate({
        address: billTo,
        validationRules: billTo.validation!,
        addressFieldDisplayCollection: addressFieldsDataView.value!.billToAddressFields,
    })(dispatch, getState);
    const { postalCode, ...otherErrors } = billingAddressErrors;
    const isBillingAddressValid = Object.keys(otherErrors).length === 0;
    dispatch({
        type: "Pages/CheckoutShipping/SetIsBillingAddressUpdateRequired",
        isBillingAddressUpdateRequired: !isBillingAddressValid,
    });
};
replaceInChain(chain, ValidateBillingAddress, ValidateBillingAddressExtended);
